import { Injectable, NgZone } from '@angular/core';
import { Platform } from '@ionic/angular';
import { Storage } from '@ionic/storage';
import { AppData } from '../app-data/app-data';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Events } from '../../services/events/events';
import { Observable, of } from 'rxjs';
import { catchError, map, tap, filter } from 'rxjs/operators';
import { Globalization } from '@awesome-cordova-plugins/globalization/ngx';

@Injectable({
    providedIn: 'root'
})
export class UserData {
    uploadProgress=0;
    favorites: string[] = [];
    HAS_LOGGED_IN = 'hasLoggedIn';
    HAS_SEEN_TUTORIAL = 'hasSeenTutorial';
    options: any;
    api_signature = '';
    device: any = {};
    private customerId: string;
    constructor(
        public storage: Storage,
        public appData: AppData,
        public platform: Platform,
        public http: HttpClient,
        //public device: Device,
        private globalization: Globalization,
        public events: Events,
        private zone: NgZone
        //public fcm: FCM,
        //private push: Push,
        // private fb: Facebook
    ) {
        this.options = new HttpHeaders({
            'Content-Type': 'application/x-www-form-urlencoded'
        });
        this.api_signature = window.localStorage.getItem(appData.getPrefix() + 'api_signature');

    }

    hasFavorite(sessionName: string): boolean {
        return (this.favorites.indexOf(sessionName) > -1);
    }

    addFavorite(sessionName: string): void {
        this.favorites.push(sessionName);
    }

    removeFavorite(sessionName: string): void {
        const index = this.favorites.indexOf(sessionName);
        if (index > -1) {
            this.favorites.splice(index, 1);
        }
    }

    /*login(username: string): Promise<any> {
      return this.storage.set(this.HAS_LOGGED_IN, true).then(() => {
        this.setUsername(username);
        return window.dispatchEvent(new CustomEvent('user:login'));
      });
    }*/
    jsonToURLEncoded(obj) { // this is ok, you need to still add some code in the api, but for apple is just to be available in the app ok got what this does is send a notificaion on phone to say what you want to say api wise like simon created a new media? correctok so
        let query = ''; let name; let value; let fullSubName; let subName; let subValue; let innerObj; let i;
        for (name in obj) {
            if (!Object.prototype.hasOwnProperty.call(obj, name)) {
                continue;
            }
            value = obj[name];

            if (Array.isArray(value)) {
                for (i = 0; i < value.length; ++i) {
                    subValue = value[i];
                    fullSubName = name + '[' + i + ']';
                    innerObj = {};
                    innerObj[fullSubName] = subValue;
                    query += this.jsonToURLEncoded(innerObj) + '&';
                }
            }
            else if (value !== null && typeof value === 'object') {
                for (subName in value) {
                    if (!Object.prototype.hasOwnProperty.call(value, subName)) {
                        continue;
                    }
                    subValue = value[subName];
                    fullSubName = name + '[' + subName + ']';
                    innerObj = {};
                    innerObj[fullSubName] = subValue;
                    query += this.jsonToURLEncoded(innerObj) + '&';
                }
            }
            else if (value !== undefined && value !== null)
                {query += encodeURIComponent(name) + '=' + encodeURIComponent(value) + '&';}
        }//api is one on server phph slim is

        return query.length ? query.substr(0, query.length - 1) : query;
    }


    private postWithEndpointFallback(primaryEndpoint: string, fallbackEndpoint: string, payload: any): Observable<any> {
        const primaryUrl = this.appData.getApiUrl() + primaryEndpoint;
        const fallbackUrl = this.appData.getApiUrl() + fallbackEndpoint;
        const data = this.jsonToURLEncoded(payload);

        return new Observable((observer) => {
            const fallback = () => {
                this.http.post(fallbackUrl, data, { headers: this.options }).subscribe(
                    (fallbackResponse) => {
                        observer.next(fallbackResponse);
                        observer.complete();
                    },
                    (fallbackError) => observer.error(fallbackError)
                );
            };

            this.http.post(primaryUrl, data, { headers: this.options }).subscribe(
                (response: any) => {
                    const errorText = String(response?.error || response?.message || '').toLowerCase();
                    if (response?.success === false && (errorText.includes('not found') || errorText.includes('unknown') || errorText.includes('route'))) {
                        fallback();
                        return;
                    }
                    observer.next(response);
                    observer.complete();
                },
                () => fallback()
            );
        });
    }

    getLanguage() {
        let language = 'en';

        if (this.getSession('language')) {
            language = this.getSession('language');
        } else if (window.Intl && typeof window.Intl === 'object') {
            this.setSession('language', navigator.language);
            language = navigator.language;
        }

        language = language.substr(0, 2);

        return language;
    }

    getDeviceLanguage() {
        this.globalization.getPreferredLanguage()
            .then(res => {
                let lang = navigator.language;
                lang = lang ? lang.substr(0, 2) : 'en';

                const translated = ['es', 'fr', 'en', 'de', 'el', 'it', 'ru'];

                if (!translated.includes(lang)) {
                    lang = 'en';
                }

                this.setSession('language', navigator.language);
            })
            .catch(e => { console.log(e); });
    }

    login(login_data) {
        const url = this.appData.getApiUrl() + 'login';
        const data = this.jsonToURLEncoded({
            login_data,
            app_version: this.appData.APP_VERSION
        });
        return this.http.post(url, data, { headers: this.options });
    };

    getSession(elem: string) {
        return window.localStorage.getItem(this.appData.getPrefix() + elem);
    };

    setSession(elem: string, val: any) {
        window.localStorage.setItem(this.appData.getPrefix() + elem, val);
    };

    removeSession(elem: string) {
        window.localStorage.removeItem(this.appData.getPrefix() + elem);
    };

    getUserBySignature(api_signature: any) {
        const url = this.appData.getApiUrl() + 'getUserBySignature';
        const data = this.jsonToURLEncoded({
            api_signature
        });
        return this.http.post(url, data, { headers: this.options });
    }

    setUserData(user: any) {
        this.setSession('user', JSON.stringify(user));
        this.setSession('api_signature', user.api_signature); // it'll be dynamic man so?
        this.api_signature = user.api_signature;
        if (user.username !== 'guest') {
            this.removeSession('GUEST_MODE');
            this.setSession('MEMBER_MODE', true);
        }
    };

    getGuestUser(): any {
        return {
            api_signature: '8f2f39ecb1ab9ec5a31728d45c05759d',
            username: 'guest',
            firstname: 'Guest',
            uid: '4',
            lastname: 'Rovespier',
            email: 'guest@rovespier.com',
        };
    }

    startGuestSession(force: boolean = false) {
        const currentUser = this.getUserData();
        if (!force && currentUser && currentUser.username && currentUser.username !== 'guest') {
            return;
        }
        const user = this.getGuestUser();
        this.setSession('HAS_LOGGED_IN', true);
        this.setUserData(user);
        this.setSession('GUEST_MODE', true);
        this.removeSession('MEMBER_MODE');
    }

    isGuestSession(): boolean {
        const user = this.getUserData();
        return !user || user.username === 'guest' || String(this.getSession('GUEST_MODE')) === 'true';
    }

    isMemberSession(): boolean {
        const user = this.getUserData();
        return String(this.getSession('HAS_LOGGED_IN')) === 'true'
            && String(this.getSession('MEMBER_MODE')) === 'true'
            && !!user
            && user.username !== 'guest';
    }

    getApiSignature(): string {
        return this.api_signature || this.getSession('api_signature') || this.getGuestUser().api_signature;
    }

    private cleanRouteId(value: any): any {
        if (value === undefined || value === null) {
            return '';
        }
        if (typeof value === 'number') {
            return Number.isFinite(value) && value > 0 ? value : '';
        }
        if (typeof value !== 'string') {
            return '';
        }
        const trimmed = value.trim();
        if (!trimmed || trimmed === '0') {
            return '';
        }
        if (/^https?:\/\//i.test(trimmed) || /\.(jpg|jpeg|png|gif|webp|avif|mp3|m4a|aac|wav|ogg|oga|flac|mp4|mov|m4v|webm|ogv|avi)(\?|$)/i.test(trimmed)) {
            return '';
        }
        return /^[A-Za-z0-9_-]{1,80}$/.test(trimmed) ? trimmed : '';
    }

    getMediaId(media: any): any {
        if (media?.media && typeof media.media === 'object') {
            const nestedMediaId = this.getMediaId(media.media);
            if (nestedMediaId) {
                return nestedMediaId;
            }
        }
        const candidates = [
            media?.msg_id, media?.msg_id_fk, media?.media_msg_id, media?.mediaMSGID,
            media?.media_id, media?.media_id_fk, media?.id_media, media?.id_msg,
            media?.msgId, media?.mediaId, media?.message_id, media?.messageId,
            media?.post_id, media?.postId, media?.mid, media?.msgid,
            media?.MSG_ID, media?.MEDIA_ID, media?.ID, media?.id
        ];
        for (const candidate of candidates) {
            const id = this.cleanRouteId(candidate);
            if (id) {
                return id;
            }
        }
        return this.cleanRouteId(media?.media);
    }

    getMediaRoute(media: any): any[] {
        const mediaId = this.getMediaId(media);
        return mediaId ? ['/media', mediaId] : ['/media'];
    }

    getEditMediaRoute(media: any): any[] {
        const mediaId = this.getMediaId(media);
        return mediaId ? ['/edit-media', mediaId] : ['/edit-media'];
    }

    getUserId(user: any): any {
        return user?.uid || user?.uid_fk || user?.id_user || user?.user_id || user?.creator_id || user?.owner_id
            || user?.author_id || user?.userId || user?.UID || user?.ID_USER || user?.id;
    }

    getUserRoute(user: any): any[] {
        const userId = this.getUserId(user);
        return userId ? ['/user', userId] : ['/user'];
    }

    cleanDisplayText(value: any): string {
        const source = String(value || '');
        if (!source) {
            return '';
        }
        const textarea = document.createElement('textarea');
        textarea.innerHTML = source;
        return textarea.value
            .replace(/<[^>]*>/g, ' ')
            .replace(/&nbsp;/gi, ' ')
            .replace(/\s+/g, ' ')
            .trim();
    }

    normalizeUser(user: any): any {
        if (!user) {
            return user;
        }
        const profileImage = this.getProfileImage(user);
        return {
            ...user,
            uid: this.getUserId(user) || user.uid,
            profile_pic: profileImage,
            profile_picture: profileImage,
            avatar: profileImage
        };
    }

    getFlowId(flow: any): any {
        const candidates = [
            flow?.group_id, flow?.group_id_fk, flow?.id_group, flow?.id_flow, flow?.flow_id, flow?.fid,
            flow?.gid, flow?.group, flow?.group_fk, flow?.groupID, flow?.flow, flow?.flow_fk,
            flow?.groupId, flow?.flowId, flow?.community_id, flow?.GROUP_ID, flow?.ID_GROUP, flow?.id
        ];
        for (const candidate of candidates) {
            const id = this.cleanRouteId(candidate);
            if (id) {
                return id;
            }
        }
        return '';
    }

    getFlowRoute(flow: any): any[] {
        const flowId = this.getFlowId(flow);
        return flowId ? ['/flow-profile', flowId] : ['/flow-profile'];
    }

    getMediaType(media: any): string {
        const rawType = String(media?.type || media?.media_type || media?.file_type || media?.mediaType || media?.format || '').toLowerCase();
        if (rawType === 'p' || rawType === 'photo' || rawType === 'image' || rawType === 'picture') {
            return 'P';
        }
        if (rawType === 'v' || rawType === 'video' || rawType === 'movie') {
            return 'V';
        }
        if (rawType === 'a' || rawType === 'audio' || rawType === 'music' || rawType === 'sound') {
            return 'A';
        }
        if (rawType === 't' || rawType === 'text' || rawType === 'poem' || rawType === 'story' || rawType === 'writing') {
            return 'T';
        }

        const file = String(media?.audio_path || media?.audio_url || media?.video_path || media?.video_url || media?.file_url || media?.media_url || media?.image_path || media?.file || '').toLowerCase();
        if (/\.(mp3|m4a|aac|wav|ogg|oga|flac)(\?|$)/.test(file)) {
            return 'A';
        }
        if (/\.(mp4|mov|m4v|webm|ogv|avi)(\?|$)/.test(file)) {
            return 'V';
        }
        if (/\.(jpg|jpeg|png|gif|webp|avif)(\?|$)/.test(file)) {
            return 'P';
        }
        return 'T';
    }

    private assetUrl(path: string, folder: string): string {
        if (!path) {
            return '';
        }
        if (/^https?:\/\//i.test(path) || path.startsWith('assets/')) {
            return path;
        }
        const cleanPath = path.replace(/^\/+/, '');
        const baseUrl = this.appData.getApiUrl().replace(/\/api\/?$/i, '/');
        if (/^(uploads|media|audio|video|mediaPic|usersPic|groupPic)\//i.test(cleanPath)) {
            return baseUrl + cleanPath;
        }
        if (cleanPath === 'default.png') {
            return baseUrl + cleanPath;
        }
        if (folder === 'mediaPic' || folder === 'usersPic' || folder === 'groupPic') {
            return baseUrl + folder + '/' + cleanPath;
        }
        if (!folder) {
            return baseUrl + 'uploads/' + cleanPath;
        }
        return baseUrl + 'uploads/' + folder + '/' + cleanPath;
    }

    normalizeMedia(media: any): any {
        if (!media) {
            return media;
        }
        const msgId = this.getMediaId(media);
        const type = this.getMediaType(media);
        const rawImagePath = media.image_path || '';
        const rawFilePath = media.file_url || media.media_url || media.file || media.path || '';
        const imagePathLooksLikeMediaFile = /\.(mp3|m4a|aac|wav|ogg|oga|flac|mp4|mov|m4v|webm|ogv|avi)(\?|$)/i.test(String(rawImagePath));
        const thumbSource = media.thumbnail || media.cover || media.poster || media.media_pic || (!imagePathLooksLikeMediaFile ? rawImagePath : '');
        const fileSource = rawFilePath || ((type === 'A' || type === 'V' || imagePathLooksLikeMediaFile) ? rawImagePath : '');
        const playableFileUrl = fileSource ? this.assetUrl(fileSource, '') : '';
        const normalizedProfileImage = this.getProfileImage(media);
        return {
            ...media,
            msg_id: media.msg_id || msgId,
            id: media.id || msgId,
            type,
            title: media.title || media.media_title || media.name || '',
            description: media.description || media.media_description || media.caption || '',
            message: media.message || media.content || media.text || media.body || '',
            username: media.username || media.creator_username || media.user_name || media.name || 'Rovespier Creator',
            profile_picture: normalizedProfileImage,
            profile_pic: normalizedProfileImage,
            avatar: normalizedProfileImage,
            creator_image: normalizedProfileImage,
            image_path: type === 'P' ? this.assetUrl(rawImagePath || thumbSource, 'mediaPic') : this.assetUrl(thumbSource, 'mediaPic'),
            media_pic: this.assetUrl(media.media_pic || thumbSource || '', 'mediaPic'),
            thumbnail: this.assetUrl(thumbSource || '', 'mediaPic'),
            file_url: playableFileUrl,
            audio_path: this.assetUrl(media.audio_path || media.audio_url || media.music_path || (type === 'A' ? fileSource : ''), ''),
            video_path: this.assetUrl(media.video_path || media.video_url || (type === 'V' ? fileSource : ''), '')
        };
    }

    getMediaFileUrl(media: any): string {
        const normalized = this.normalizeMedia(media);
        const type = this.getMediaType(normalized);
        if (type === 'A') {
            return normalized?.audio_path || normalized?.audio_url || normalized?.music_path || normalized?.media_url
                || normalized?.file_url || normalized?.file || normalized?.image_path || '';
        }
        if (type === 'V') {
            return normalized?.video_path || normalized?.video_url || normalized?.media_url || normalized?.file_url || normalized?.file || normalized?.image_path || '';
        }
        return normalized?.file_url || normalized?.media_url || normalized?.image_path || normalized?.media_pic || normalized?.thumbnail || normalized?.file || '';
    }

    getMediaImage(media: any, fallback: string = 'assets/img/user.png'): string {
        const normalized = this.normalizeMedia(media);
        if (this.getMediaType(normalized) === 'P') {
            return normalized?.image_path || normalized?.thumbnail || normalized?.media_pic || normalized?.file_url || normalized?.media_url || fallback;
        }
        return normalized?.thumbnail || normalized?.poster || normalized?.image_path || normalized?.media_pic || fallback;
    }

    getProfileImage(user: any, fallback: string = 'assets/img/user.png'): string {
        const rawProfilePic = user?.profile_picture || user?.profile_pic || user?.avatar || user?.creator_image || '';
        const profilePic = String(rawProfilePic || '').trim();

        if (!profilePic) {
            return this.assetUrl('default.png', '') || fallback;
        }

        if (/^https?:\/\//i.test(profilePic)) {
            return profilePic;
        }

        const cleanProfilePic = profilePic.replace(/^\/+/, '');
        if (/^(null|undefined|none|creator|profile|user)$/i.test(cleanProfilePic)) {
            return this.assetUrl('default.png', '') || fallback;
        }
        if (/^(assets\/|default\.png$)/i.test(cleanProfilePic)) {
            return this.assetUrl(cleanProfilePic, '') || fallback;
        }
        if (/^(api\/)?usersPic\//i.test(cleanProfilePic)) {
            return this.assetUrl(cleanProfilePic.replace(/^api\//i, ''), 'usersPic') || fallback;
        }
        if (/^usersPic\//i.test(cleanProfilePic)) {
            return this.assetUrl(cleanProfilePic, 'usersPic') || fallback;
        }

        return this.assetUrl(cleanProfilePic, 'usersPic') || fallback;
    }


    getUserData(): any {
        const storedUser = this.getSession('user');
        if (!storedUser) return null;
        try {
            const userData = JSON.parse(storedUser);
            return userData && typeof userData === 'object' && !Array.isArray(userData) ? userData : null;
        } catch {
            return null;
        }
    }

    hasLoggedIn() {
        return this.getSession('HAS_LOGGED_IN') == 'true';
    };

    signup(signup_data: any) {

        const url = this.appData.getApiUrl() + 'signup';
        const data = this.jsonToURLEncoded({
            signup_data,
            app_version: this.appData.APP_VERSION
        });

        return this.http.post(url, data, { headers: this.options });
    };

    logout(): Promise<any> {
        this.removeSession('HAS_LOGGED_IN');
        this.removeSession('GUEST_MODE');
        this.removeSession('MEMBER_MODE');
        this.removeSession('user');
        this.removeSession('api_signature');
        this.api_signature = '';
        return this.storage.remove(this.HAS_LOGGED_IN).then(() => this.storage.remove('username')).then(() => {
            window.dispatchEvent(new CustomEvent('user:logout'));
        });
    }

    setUsername(username: string): Promise<any> {
        return this.storage.set('username', username);
    }

    getUsername(): Promise<string> {
        return this.storage.get('username').then((value) => value);
    }

    isLoggedIn(): Promise<boolean> {
        return this.storage.get(this.HAS_LOGGED_IN).then((value) => value === true);
    }

    checkHasSeenTutorial(): Promise<string> {
        return this.storage.get(this.HAS_SEEN_TUTORIAL).then((value) => value);
    }




    allArtists(offset: number) {
        const url = this.appData.getApiUrl() + 'allArtists';
        /*
        const requestOptions = {
          params: new HttpParams()
        };
        */
        if (this.api_signature) {
            const data = this.jsonToURLEncoded({
                api_signature: this.api_signature,
                offset
            });
            return this.http.post(url, data, { headers: this.options });
        } else {
            const data = this.jsonToURLEncoded({
                api_signature: '8f2f39ecb1ab9ec5a31728d45c05759d',//this is guest got itok continue ok
                offset
            });
            return this.http.post(url, data, { headers: this.options });
            //return this.http.post(url, data, requestOptions );
        }
    }

    searchArtisticBehaviour(creativity: string) {
        const url = this.appData.getApiUrl() + 'searchByArtisticBehaviour';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
            creativity
        });
        return this.http.post(url, data, { headers: this.options });
    }

    searchByCountry(country: string) {
        const url = this.appData.getApiUrl() + 'searchByCountry';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
            country
        });
        return this.http.post(url, data, { headers: this.options });
    }

    allMedias(offset: number) {
        const url = this.appData.getApiUrl() + 'allMedia';
        if (this.api_signature) {
            const data = this.jsonToURLEncoded({
                api_signature: this.api_signature,
                offset
            });
            return this.http.post(url, data, { headers: this.options });
        }
        else {
            const data = this.jsonToURLEncoded({
                api_signature: '8f2f39ecb1ab9ec5a31728d45c05759d',
                offset
            });
            return this.http.post(url, data, { headers: this.options });
        }

    }

    topMedias(offset: number, range: string = '30days') {
        const url = this.appData.getApiUrl() + 'topMedia';
        const data = this.jsonToURLEncoded({
            api_signature: this.getApiSignature() || '8f2f39ecb1ab9ec5a31728d45c05759d',
            offset,
            range
        });
        return this.http.post(url, data, { headers: this.options }).pipe(
            catchError(() => this.allMedias(offset).pipe(
                map((fallback: any) => ({
                    success: !!fallback?.success,
                    count: (fallback?.allMedia || fallback?.mediaFeed || fallback?.medias || []).length,
                    topMedia: fallback?.allMedia || fallback?.mediaFeed || fallback?.medias || []
                })),
                catchError(() => of({ success: false, count: 0, topMedia: [] }))
            ))
        );
    }

    topReviews(offset: number) {
        const url = this.appData.getApiUrl() + 'topReviews';
        const data = this.jsonToURLEncoded({
            api_signature: this.getApiSignature(),
            offset
        });
        return this.http.post(url, data, { headers: this.options });
    };

    allFlow(offset: number) {
        const url = this.appData.getApiUrl() + 'allFlows';
        const data = this.jsonToURLEncoded({
            api_signature: this.getApiSignature(),
            offset
        });
        return this.http.post(url, data, { headers: this.options });
    }

    friendsList(uid, offset: number) {
        const url = this.appData.getApiUrl() + 'friendsList';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
            uid,
            offset
        });
        return this.http.post(url, data, { headers: this.options });
    }

    mediasList(uid, offset: number) {
        const url = this.appData.getApiUrl() + 'mediaList';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
            uid,
            offset
        });

        return this.http.post(url, data, { headers: this.options });
    }

    mediaAdList(offset: number) {
        const url = this.appData.getApiUrl() + 'adDetails';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
            offset
        });

        return this.http.post(url, data, { headers: this.options });
    }



    createPressRelease(release_data: any) {
        const url = this.appData.getApiUrl() + 'createPressRelease';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
            release_data
        });
        return this.http.post(url, data, { headers: this.options });
    };

    pressReleasesList() {
        const url = this.appData.getApiUrl() + 'pressReleases';
        const data = this.jsonToURLEncoded({
          api_signature: this.api_signature
        });

        return this.http.post(url, data, { headers: this.options });
      }

      updateReleaseStatus(releaseIds: number[]): Observable<any> {
        const url = this.appData.getApiUrl() + 'updatePressReleaseStatus'; // Adjust the URL to your API endpoint
        const data = this.jsonToURLEncoded({
          api_signature: this.api_signature,
          releaseIds // Pass an array of release IDs to the API
        });

        return this.http.post(url, data, { headers: this.options });
      }

    flowsList(uid, offset: number) {
        const url = this.appData.getApiUrl() + 'flowsList';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
            uid,
            offset
        });
        return this.http.post(url, data, { headers: this.options });
    }

    createFlow(flow_data: any) {
        const url = this.appData.getApiUrl() + 'createFlow';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
            flow_data
        });
        return this.http.post(url, data, { headers: this.options });
    };

    updateFlow(group_id, flow_data: any) {
        const url = this.appData.getApiUrl() + 'updateFlow';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
            group_id,
            flow_data
        });
        return this.http.post(url, data, { headers: this.options });
    };

    flowDetails(flow) {
        const url = this.appData.getApiUrl() + 'flowDetails';
        const data = this.jsonToURLEncoded({
            api_signature: this.getApiSignature(),
            flow
        });

        return this.http.post(url, data, { headers: this.options });
    }

/*
      createCustomer(payment) {
        const url = this.appData.getApiUrl() + 'createCustomer';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
            payment: payment
        });

        return this.http.post(url, data, { headers: this.options });
    }
    */

    createCustomer(email: string) {
        const url = this.appData.getApiUrl() + 'createCustomer';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
            email
        });

        return this.http.post(url, data, { headers: this.options });
    }

    createSetupIntent(customerId:string) {return this.desktopPost('createSetupIntent',{customerId});}
    createSubscription(customerId:string,planId:string,paymentMethodId:string,email='',setupIntentId='') {return this.desktopPost('createSubscription',{customerId,planId,paymentMethodId,email,setupIntentId});}
    createSubscriptionGoogle(customerId:string,planId:string,token:string,email='') {return this.createSubscription(customerId,planId,token,email);}

    usersInterest(item, offset: number) {
        const url = this.appData.getApiUrl() + 'usersInterest';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
            item,
            offset
        });

        return this.http.post(url, data, { headers: this.options });
    }

    usersByArtists(item, offset: number) {
        const url = this.appData.getApiUrl() + 'usersByArtist';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
            item,
            offset
        });

        return this.http.post(url, data, { headers: this.options });
    }

    usersByArtisticBehaviour(item, offset: number) {
        const url = this.appData.getApiUrl() + 'usersByArtisticBehaviour';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
            item,
            offset
        });

        return this.http.post(url, data, { headers: this.options });
    }

    getActivityFlow(flow_id: number, offset: number) {
        const url = this.appData.getApiUrl() + 'getActivityFlow';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
            flow_id,
            offset
        });
        return this.http.post(url, data, { headers: this.options });
    }

    getActivityUser(offset: number, uid: number) {
        const url = this.appData.getApiUrl() + 'getActivityUser';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
            offset,
            uid
        });

        return this.http.post(url, data, { headers: this.options });
    }

    getActivityMedia(msg_id: number, offset: number) {
        const url = this.appData.getApiUrl() + 'getActivityMedia';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
            offset,
            msg_id
        });

        return this.http.post(url, data, { headers: this.options });
    }


    private uploadMediaWithOptionalFile(endpoint: string, media: any, group_id: number) {
        const url = this.appData.getApiUrl() + endpoint;
        if (media && media.file) {
            const formData = new FormData();
            const file = media.file;
            const cleanMedia = { ...media };
            delete cleanMedia.file;
            formData.append('api_signature', this.api_signature || '');
            formData.append('media', JSON.stringify(cleanMedia));
            formData.append('group_id', String(group_id || 0));
            formData.append('file', file, file.name || 'media-file');
            this.uploadProgress=0;
            return this.http.post(url,formData,{observe:'events',reportProgress:true}).pipe(tap((event:any)=>{if(event.type===1 && event.total)this.uploadProgress=Math.round(event.loaded/event.total*100);}),filter((event:any)=>event.type===4),map((event:any)=>event.body));
        }
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
            media: endpoint === 'uploadText' ? media : JSON.stringify(media),
            group_id
        });
        return this.http.post(url, data, { headers: this.options });
    }

    uploadText(media: any, group_id: number) {
        return this.uploadMediaWithOptionalFile('uploadText', media, group_id);
    }

    uploadPhoto(media: any, group_id: number) {
        return this.uploadMediaWithOptionalFile('uploadPhoto', media, group_id);
    }

    uploadAudio(media: any, group_id: number) {
        return this.uploadMediaWithOptionalFile('uploadAudio', media, group_id);
    }

    uploadVideo(media: any, group_id: number) {
        return this.uploadMediaWithOptionalFile('uploadVideo', media, group_id);
    }

    createSession(session: any) {
        const url = this.appData.getApiUrl() + 'createSession';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
            title: session.title,
            description: session.description,
            media_type: session.media_type || session.type || 'V',
            category: session.category || '',
            creative_interest: session.creative_interest || '',
            visibility: session.visibility || 'public',
            role: session.role || 'video',
            nearby_enabled: session.nearby_enabled ? 1 : 0,
            latitude: session.latitude || '',
            longitude: session.longitude || ''
        });
        return this.http.post(url, data, { headers: this.options });
    }

    generateSessionCode(length: number = 6) {
        // The current backend generates the official code inside createSession().
        return new Observable((observer) => {
            const alphabet = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
            let code = '';
            for (let i = 0; i < length; i++) {
                code += alphabet[Math.floor(Math.random() * alphabet.length)];
            }
            observer.next({ success: true, code });
            observer.complete();
        });
    }

    joinSession(code: string, role: string = 'video') {
        const url = this.appData.getApiUrl() + 'joinSession';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
            session_code: code,
            role
        });
        return this.http.post(url, data, { headers: this.options });
    }

    inviteSessionFriends(sessionId: number, friends: any[]) {
        const url = this.appData.getApiUrl() + 'inviteSessionFriends';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
            session_id: sessionId,
            friends
        });
        return this.http.post(url, data, { headers: this.options });
    }

    getSessionDetails(sessionId: number) {
        const url = this.appData.getApiUrl() + 'getSessionDetails';
        const data = this.jsonToURLEncoded({ api_signature: this.api_signature, session_id: sessionId });
        return this.http.post(url, data, { headers: this.options });
    }

    chooseSessionRole(sessionId: number, role: string = 'video') {
        const url = this.appData.getApiUrl() + 'chooseSessionRole';
        const data = this.jsonToURLEncoded({ api_signature: this.api_signature, session_id: sessionId, role });
        return this.http.post(url, data, { headers: this.options });
    }

    acceptSessionInvite(sessionId: number, role: string = 'video') {
        const url = this.appData.getApiUrl() + 'acceptSessionInvite';
        const data = this.jsonToURLEncoded({ api_signature: this.api_signature, session_id: sessionId, role });
        return this.http.post(url, data, { headers: this.options });
    }

    leaveSession(sessionId: number) {
        const url = this.appData.getApiUrl() + 'leaveSession';
        const data = this.jsonToURLEncoded({ api_signature: this.api_signature, session_id: sessionId });
        return this.http.post(url, data, { headers: this.options });
    }

    setSessionReady(sessionId: number, ready: boolean) {
        const url = this.appData.getApiUrl() + 'setSessionReady';
        const data = this.jsonToURLEncoded({ api_signature: this.api_signature, session_id: sessionId, ready: ready ? 1 : 0 });
        return this.http.post(url, data, { headers: this.options });
    }

    startSessionRecording(sessionId: number) {
        const url = this.appData.getApiUrl() + 'startSessionRecording';
        const data = this.jsonToURLEncoded({ api_signature: this.api_signature, session_id: sessionId });
        return this.http.post(url, data, { headers: this.options });
    }

    stopSessionRecording(sessionId: number) {
        const url = this.appData.getApiUrl() + 'stopSessionRecording';
        const data = this.jsonToURLEncoded({ api_signature: this.api_signature, session_id: sessionId });
        return this.http.post(url, data, { headers: this.options });
    }

    publishSession(sessionId: number) {
        const url = this.appData.getApiUrl() + 'publishSession';
        const data = this.jsonToURLEncoded({ api_signature: this.api_signature, session_id: sessionId });
        return this.http.post(url, data, { headers: this.options });
    }

    cancelSession(sessionId: number) {
        const url = this.appData.getApiUrl() + 'cancelSession';
        const data = this.jsonToURLEncoded({ api_signature: this.api_signature, session_id: sessionId });
        return this.http.post(url, data, { headers: this.options });
    }

    mediaOnFlowProfile(flow) {
        const url = this.appData.getApiUrl() + 'mediaFlowProfile';
        const data = this.jsonToURLEncoded({
            api_signature: this.getApiSignature(),
            flow
        });
        return this.http.post(url, data, { headers: this.options });
    }

    flowMembers(flow) {
        const url = this.appData.getApiUrl() + 'flowMembers';
        const data = this.jsonToURLEncoded({
            api_signature: this.getApiSignature(),
            flow
        });
        return this.http.post(url, data, { headers: this.options });
    }

    searchUsers(
        query: string,
        country: string = 'all',
        creativity: string = 'all',
        media: string = 'all',
        offset: number = 0
    ) {
        const url = this.appData.getApiUrl() + 'searchUsers';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
            query,
            country,
            creativity,
            media,
            offset
        });
        return this.http.post(url, data, { headers: this.options });
    }

    searchMedia(query: string, type: string = 'all', offset: number = 0) {
        const url = this.appData.getApiUrl() + 'searchMedia';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
            query,
            type,
            offset
        });
        return this.http.post(url, data, { headers: this.options });
    }

    searchUser() {
        const url = this.appData.getApiUrl() + 'userGroupSearch';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature
        });
        return this.http.post(url, data, { headers: this.options });
    }

    homeFeed(offset: number) {
        const url = this.appData.getApiUrl() + 'newsFeed';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
            offset
        });
        return this.http.post(url, data, { headers: this.options });
    }

    followUser(fid: number, username: string) {
        const url = this.appData.getApiUrl() + 'addFriend';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature, // I think we can keep the changes here in the ionic part, and then just use the old php version ok so it will work now? i mean this?
            fid,
            username // so all parameters you put here will be avialabel in $_POST in the server leave this comment
        });
        return this.http.post(url, data, { headers: this.options });
    }

    unfollowUser(fid: number) {
        const url = this.appData.getApiUrl() + 'removeFriend';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
            fid
        });
        return this.http.post(url, data, { headers: this.options });
    }

    mediaEditors(msg_id: number, offset: number) {
        const url = this.appData.getApiUrl() + 'mediaEditors';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature || this.getSession('api_signature'),
            msg_id,
            offset
        });
        return this.http.post(url, data, { headers: this.options });
    }

    mediaDetails(msg_id: number) {
        const url = this.appData.getApiUrl() + 'mediaDetails';
        const data = this.jsonToURLEncoded({
            api_signature: this.getApiSignature(),
            msg_id
        });
        return this.http.post(url, data, { headers: this.options });
    }

    addMediaReport(report: any) {//user data function
        const url = this.appData.getApiUrl() + 'mediaReport';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
            report
        });
        return this.http.post(url, data, { headers: this.options });
    };

    addUserReport(report: any) {//user data function
        const url = this.appData.getApiUrl() + 'userReport';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
            report
        });
        return this.http.post(url, data, { headers: this.options });
    };

    peopleWhoViewedMedia(msg_id: number, offset: number) {
        const url = this.appData.getApiUrl() + 'peopleWhoViewedMedia';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
            msg_id,
            offset
        });
        return this.http.post(url, data, { headers: this.options });
    }

    peoplePoints(msg_id: number, offset: number) {
        const url = this.appData.getApiUrl() + 'peopleGivePoints';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
            msg_id,
            offset
        });
        return this.http.post(url, data, { headers: this.options });
    }

    mediaDelete(msg_id: number) {
        const url = this.appData.getApiUrl() + 'mediaDelete';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
            msg_id
        });
        return this.http.post(url, data, { headers: this.options });
    }

    cancelSubscription(customer_id: number) {
        const url = this.appData.getApiUrl() + 'cancelSubscription';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
            customer_id
        });
        return this.http.post(url, data, { headers: this.options });
    }

    mediaSplit(msg_id: number, pieces: number) {
        const url = this.appData.getApiUrl() + 'mediaSplit';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
            msg_id,
            pieces
        });
        return this.http.post(url, data, { headers: this.options });
    }

    mediaPieces(msg_id: number) {
        const url = this.appData.getApiUrl() + 'mediaPieces';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
            msg_id
        });
        return this.http.post(url, data, { headers: this.options });
    }

    deActivate() {
        const url = this.appData.getApiUrl() + 'userDeactivate';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature
        });
        return this.http.post(url, data, { headers: this.options });
    }

    reviewMedia(review_data: any) {//and this the function that ends to apiok
        const url = this.appData.getApiUrl() + 'reviewMedia';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
            review_data
        });
        return this.http.post(url, data, { headers: this.options });
    };

    givePoints(media: any, points: number) {
        const url = this.appData.getApiUrl() + 'givePoints';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
            media,
            points
        });

        return this.http.post(url, data, { headers: this.options });
    }

    updatePoints(media: any, points: number, pointsOld: number) {
        const url = this.appData.getApiUrl() + 'updateUserPoints';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
            media,
            points,
            pointsOld
        });
        return this.http.post(url, data, { headers: this.options });
    }

    getMessages(offset: number) {
        const url = this.appData.getApiUrl() + 'userMessages';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
            offset
        });
        return this.http.post(url, data, { headers: this.options });
    }

    setNotification(c_id_fk: number) {
        const url = this.appData.getApiUrl() + 'markMessageRead';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
            c_id_fk
        });
        return this.http.post(url, data, { headers: this.options });
    }

    getNotifications(offset: number) {
        const url = this.appData.getApiUrl() + 'getNotifications';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
            offset
        });
        return this.http.post(url, data, { headers: this.options });
    }

    deleteNotifications(id_notification: number, deleted: boolean) {
        const url = this.appData.getApiUrl() + 'deleteNotification';
        const data = this.jsonToURLEncoded({
            id_notification,
            deleted
        });
        return this.http.post(url, data, { headers: this.options });
    }

    getMediaReviews(msg_id: number) {
        const url = this.appData.getApiUrl() + 'getMediaReviews';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
            msg_id
        });

        return this.http.post(url, data, { headers: this.options });
    };

    changePassword(password: string) {
        const url = this.appData.getApiUrl() + 'changePassword';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
            password
        });
        return this.http.post(url, data, { headers: this.options });
    }

    updateUserSettings(user: any) {
        const url = this.appData.getApiUrl() + 'updateUserSettings';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
            user
        });
        return this.http.post(url, data, { headers: this.options });
    }

    getSettings() {
        const url = this.appData.getApiUrl() + 'creativeSettings';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
        });
        return this.http.post(url, data, { headers: this.options });
    }

    async resetPassword(email)
    {

    }



    appleLogin(login_data) {
        const device = {};

        if (this.platform.is('cordova')) {
            /*device = {
                platform: this.device.platform,
                uuid: this.device.uuid,
                cordova: this.device.cordova,
                model: this.device.model,
                manufacturer: this.device.manufacturer,
                version: this.device.version,
            };*/
        }

        let timezone_offset = new Date().getTimezoneOffset();
        timezone_offset = timezone_offset == 0 ? 0 : -timezone_offset;

        const url = this.appData.getApiUrl() + 'sign_in_with_apple';
        const data = this.jsonToURLEncoded({
            login_data,
            device,
            app_version: this.appData.APP_VERSION,
            timezone_offset
        });

        return this.http.post(url, data, { headers: this.options });
    };

    facebookLogin(login_data) {
        const device = {};

        if (this.platform.is('cordova')) {
          /*  device = {
                platform: this.device.platform,
                uuid: this.device.uuid,
                model: this.device.model,
                manufacturer: this.device.manufacturer,
                version: this.device.version,
            };*/
        }

        let timezone_offset = new Date().getTimezoneOffset();
        timezone_offset = timezone_offset == 0 ? 0 : -timezone_offset;

        const url = this.appData.getApiUrl() + 'facebookLogin';
        const data = this.jsonToURLEncoded({
            login_data,
            device,
            app_version: this.appData.APP_VERSION,
            timezone_offset
        });
        return this.http.post(url, data, { headers: this.options });
    };

    //this one man so i add this in login? and it needs an api function right? you need to get data from this as you see below
    googleLogin(login_data) {
        const device = {};

        if (this.platform.is('cordova')) {
           /* device = {
                platform: this.device.platform,
                uuid: this.device.uuid,
                model: this.device.model,
                manufacturer: this.device.manufacturer,
                version: this.device.version,
            };*/
        }

        let timezone_offset = new Date().getTimezoneOffset();
        timezone_offset = timezone_offset == 0 ? 0 : -timezone_offset;

        const url = this.appData.getApiUrl() + 'googleLoginWebsite';
        const data = this.jsonToURLEncoded({
            login_data,
            device,
            app_version: this.appData.APP_VERSION,
            timezone_offset
        });
        return this.http.post(url, data, { headers: this.options });
    }

    userProfile() {
        const url = this.appData.getApiUrl() + 'updateNewsFeed';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
        });

        return this.http.post(url, data, { headers: this.options });
    }

    userDetails(uid) {
        const url = this.appData.getApiUrl() + 'userDetails';
        const data = this.jsonToURLEncoded({
            api_signature: this.getApiSignature(),
            uid
        });
        return this.http.post(url, data, { headers: this.options });
    }

    tagDetails(tag: string, id: number, source: string) {
        const url = this.appData.getApiUrl() + 'tagDetails';
        const data = this.jsonToURLEncoded({
            tag,
            id,
            source,
        });
        return this.http.post(url, data, { headers: this.options });
    }

    usersMedia(uid, offset: number) {
        const url = this.appData.getApiUrl() + 'usersMedia';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
            uid,
            offset
        });

        return this.http.post(url, data, { headers: this.options });
    }

    usersFriends(uid, offset: number) {
        const url = this.appData.getApiUrl() + 'usersFriends';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
            uid,
            offset
        });

        return this.http.post(url, data, { headers: this.options });
    }

    usersFlow(uid: any, offset: number) {
        const url = this.appData.getApiUrl() + 'usersFlow';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
            uid,
            offset
        });
        return this.http.post(url, data, { headers: this.options });
    }

    saveProfile(user) {
        const url = this.appData.getApiUrl() + 'updateUserSettings';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
            user
        });
        return this.http.post(url, data, { headers: this.options });
    }

    sendMedia(msgId: number, userOne: number, userTwo: number) {
        const url = this.appData.getApiUrl() + 'sendMessage';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature, // I think we can keep the changes here in the ionic part, and then just use the old php version ok so it will work now? i mean this?
            msgId,
            user_one: userOne,
            user_two: userTwo,
            message_data: 'Shared media'
        });
        return this.http.post(url, data, { headers: this.options });
    }

    changeStatus(msg_id: number, status: boolean) {
        const url = this.appData.getApiUrl() + 'updateMediaStatus';
        const data = this.jsonToURLEncoded({
            msg_id,
            status
        });
        return this.http.post(url, data, { headers: this.options });
    }

    creativeInterestsUser(uid: number) {
        const url = this.appData.getApiUrl() + 'getCreativeInterestsUser';
        const data = this.jsonToURLEncoded({
            uid
        });
        return this.http.post(url, data, { headers: this.options });
    }

    artistsInterestsUser(uid: number) {
        const url = this.appData.getApiUrl() + 'getArtistInterestsUser';
        const data = this.jsonToURLEncoded({
            uid
        });
        return this.http.post(url, data, { headers: this.options });
    }
    creativeInterests(uid: number) {
        const url = this.appData.getApiUrl() + 'getCreativeInterests';
        const data = this.jsonToURLEncoded({
            uid
        });
        return this.http.post(url, data, { headers: this.options });
    }

    creativeInterestsMedia(msg_id: number) {
        const url = this.appData.getApiUrl() + 'getCreativeInterestsMedia';
        const data = this.jsonToURLEncoded({
            msg_id
        });
        return this.http.post(url, data, { headers: this.options });
    }

    artistsInterests(uid: number) {
        const url = this.appData.getApiUrl() + 'getArtistInterests';
        const data = this.jsonToURLEncoded({
            uid
        });
        return this.http.post(url, data, { headers: this.options });
    }

    creativeSettings(uid: number, id_interest: any, active: boolean) {
        const url = this.appData.getApiUrl() + 'creativeSettings';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
            uid,
            id_interest,
            active
        });
        return this.http.post(url, data, { headers: this.options });
    }

    creativeSettingsMedia(msg_id: number, id_interest: any,name: any, active: boolean) {
        const url = this.appData.getApiUrl() + 'creativeSettingsMedia';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
            msg_id,
            id_interest,
            name,
            active
        });
        return this.http.post(url, data, { headers: this.options });
    }

    artistSettings(uid: number, id_artist_interest: any, active: boolean) {
        const url = this.appData.getApiUrl() + 'artistSettings';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
            uid,
            id_artist_interest,
            active
        });
        return this.http.post(url, data, { headers: this.options });
    }

    flowViewed(flow: any) {
        const url = this.appData.getApiUrl() + 'flowViewed';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
            flow
        });
        return this.http.post(url, data, { headers: this.options });
    }

    mediaViewed(media: any) {
        const url = this.appData.getApiUrl() + 'mediaViewed';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
            media
        });
        return this.http.post(url, data, { headers: this.options });
    }

    joinFlow(fid: number, flowname: string) {
        const url = this.appData.getApiUrl() + 'joinFlow';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
            fid,
            flowname
        });

        return this.http.post(url, data, { headers: this.options });
    }

    removeFlow(fid: number) {
        const url = this.appData.getApiUrl() + 'removeFlow';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
            fid
        });
        return this.http.post(url, data, { headers: this.options });
    }

    showMessages(offset: number) {
        const url = this.appData.getApiUrl() + 'userMessages';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
            offset
        });

        return this.http.post(url, data, { headers: this.options });
    }

    singleMessage(message: any) {
        const url = this.appData.getApiUrl() + 'singleMessage';
        const c_id = typeof message === 'object'
            ? (message.c_id || message.c_id_fk || message.id_notification || message.id)
            : message;
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
            c_id
        });
        return this.http.post(url, data, { headers: this.options });
    }

    sendMessage(userOne: number, userTwo: number, message_data) {
        const url = this.appData.getApiUrl() + 'sendMessage';//SE STILL PASS CID IT SHOULD PASS USER_ONE AND USER_TWO RECIEICER AND SENDER ID RIGHT?ok
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature, // I think we can keep the changes here in the ionic part, and then just use the old php version ok so it will work now? i mean this?
            user_one: userOne,
            user_two: userTwo,
            message_data
        });
        return this.http.post(url, data, { headers: this.options });
    }

    recoverPassword(email: string) {
        const url = this.appData.getApiUrl() + 'recoverPassword';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
            email
        });
        return this.http.post(url, data, { headers: this.options });
    }

    editMediaData(media_data: any) {
        const url = this.appData.getApiUrl() + 'editMediaData';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
            mediaData: media_data
        });

        return this.http.post(url, data, { headers: this.options });
    }

    editMedia(media_data: any, fileType?: 'image' | 'audio' | 'video', file?: File) {
        const url = this.appData.getApiUrl() + 'editMedia';

        if (fileType && file) {
            const formData = new FormData();
            formData.append('api_signature', this.api_signature || '');
            formData.append('mediaData', JSON.stringify(media_data || {}));
            formData.append('fileType', fileType);
            const fileField = fileType === 'image' ? 'imageFile' : fileType === 'audio' ? 'audioFile' : 'videoFile';
            formData.append(fileField, file, file.name);
            return this.http.post(url, formData);
        }

        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
            mediaData: media_data
        });

        return this.http.post(url, data, { headers: this.options });
    }

    getFileExtension(fileName: string) {
        const filExtension = fileName.substr(fileName.lastIndexOf('.') + 1);
        return filExtension;
    }

    requestForPayment(request): Observable<any> {
        const url = this.appData.getApiUrl() + 'requestForPayment';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
            payment: request
        });

        /* yes man i know ill doOKSORRY np mediaData what will be here ?YOU S AID YOU KNEW MAN HAHA  I know the params where to pss but dont know
        what requirest params because its backend thing*/

        return this.http.post(url, data, { headers: this.options });
    }

    createPaymentIntent(paymentDetails: any): Observable<any> {
        const url = this.appData.getApiUrl() + 'createPaymentIntent';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
            ...paymentDetails
        });
        return this.http.post(url, data, { headers: this.options });
    }

    insertMediaOfferDetails(offerDetails: any): Observable<any> {
        const url = this.appData.getApiUrl() + 'insertMediaSellingDetails';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
            sellingDetails: offerDetails
        });
        return this.http.post(url, data, { headers: this.options });
    }

    insertSellingDetails(sellingDetails: any): Observable<any> {
        return this.insertMediaOfferDetails(sellingDetails);
    }

    getCreatorStripeStatus(createOnboarding = false): Observable<any> {
        const url = this.appData.getApiUrl() + 'creatorStripeStatus';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
            create_onboarding: createOnboarding ? 1 : 0
        });
        return this.http.post(url, data, { headers: this.options });
    }

    getMediaPriceDetails(msg_id: number): Observable<any> {
        const url = this.appData.getApiUrl() + 'mediaPriceDetails';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
            msg_id
        });
        return this.http.post(url, data, { headers: this.options });
    }

    getSoldMediaDetails(uid: number): Observable<any> {
        const url = this.appData.getApiUrl() + 'soldMediaDetails';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
            uid
        });
        return this.http.post(url, data, { headers: this.options });
    }

    getPurchasedMediaDetails(uid: number): Observable<any> {
        const url = this.appData.getApiUrl() + 'purchaseBuyerDetails';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
            uid
        });
        return this.http.post(url, data, { headers: this.options });
    }

    purchaseMediaFractions(purchaseDetails: any): Observable<any> {
        const url = this.appData.getApiUrl() + 'insertMediaPurchaseDetails';
        const data = {
            api_signature: this.api_signature,
            purchaseDetails
        };
        return this.http.post(url, this.jsonToURLEncoded(data), { headers: this.options });
    }

    updateMediaOfferDetails(mediaId: any): Observable<any> {
        const url = this.appData.getApiUrl() + 'updateMediaSellingDetails';
        const data = this.jsonToURLEncoded({
            api_signature: this.api_signature,
            mediaId
        });
        return this.http.post(url, data, { headers: this.options });
    }

    hasAuthenticatedSession(): boolean {
        return this.isMemberSession();
    }

    createMediaUnlockPayment(msgId: number): Observable<any> {
        const url = this.appData.getApiUrl() + 'createMediaUnlockPayment';
        const data = this.jsonToURLEncoded({
            api_signature: this.getApiSignature(),
            msg_id: msgId
        });
        return this.http.post(url, data, { headers: this.options });
    }

    mediaUnlockStatus(msgId: number): Observable<any> {
        const url = this.appData.getApiUrl() + 'mediaUnlockStatus';
        const data = this.jsonToURLEncoded({
            api_signature: this.getApiSignature(),
            msg_id: msgId
        });
        return this.http.post(url, data, { headers: this.options });
    }

    myUnlockedMedia(offset: number = 0, limit: number = 50): Observable<any> {
        const url = this.appData.getApiUrl() + 'myUnlockedMedia';
        const data = this.jsonToURLEncoded({
            api_signature: this.getApiSignature(),
            offset,
            limit
        });
        return this.http.post(url, data, { headers: this.options });
    }

    extractMediaAccess(response: any, media?: any): any {
        const access = response?.access_state || response?.access || response?.data?.access_state
            || response?.data?.access || response?.media?.access_state || response?.mediaDetails?.access_state;
        if (access) { return access; }
        if (typeof response?.has_access === 'boolean') {
            return {
                access_type: media?.access_type || 'paid',
                has_access: response.has_access,
                is_owner: response.is_owner === true,
                requires_payment: response.has_access !== true,
                price_minor: response.price_minor || media?.unlock_price_minor,
                currency: response.currency || media?.unlock_currency
            };
        }
        return media?.access_state || media?.access || null;
    }

    applyMediaAccess(media: any, access: any): any {
        if (!media || !access) { return media; }
        media.access_state = { ...(media.access_state || {}), ...access };
        media.access = media.access_state;
        media.is_owner = media.access_state.is_owner === true;
        media.requires_payment = media.access_state.requires_payment === true;
        media.has_access = media.access_state.has_access === true;
        return media;
    }


    hasCollaborationSession():boolean {return this.isMemberSession() && !!this.getApiSignature();}
    collaboration(action:string,payload:any={}) {return this.http.post(this.appData.getApiUrl()+'collaboration',this.jsonToURLEncoded({...payload,action,api_signature:this.getApiSignature()}),{headers:this.options});}
    collaborationUpload(form:FormData) {form.set('action','submit');form.set('api_signature',this.getApiSignature());return this.http.post(this.appData.getApiUrl()+'collaboration',form);}
    collaborationAsset(id:number) {return this.http.post(this.appData.getApiUrl()+'collaboration',this.jsonToURLEncoded({action:'asset',submission_id:id,api_signature:this.getApiSignature()}),{headers:this.options,responseType:'blob'});}
    mediaPermissions(msg_id:number) {return this.desktopPost('mediaPermissions',{msg_id});}
    updateMediaEditors(mediaData:any) {return this.desktopPost('updateMediaEditors',{mediaData:{...mediaData,editors:JSON.stringify(mediaData.editors || [])}});}
    notificationSeen(id_notification:number) {return this.desktopPost('setNotificationSeen',{id_notification});}
    activeFlowBrief(flow:any) {return this.desktopPost('activeFlowBrief',{flow});}
    createFlowBrief(brief:any) {return this.desktopPost('createFlowBrief',{brief});}
    submitFlowBriefMedia(brief_id:number,msg_id:number) {return this.desktopPost('submitFlowBriefMedia',{brief_id,msg_id});}
    mediaLineage(msg_id:number) {return this.desktopPost('mediaLineage',{msg_id});}
    createMediaRelationship(source_msg_id:number,target_msg_id:number,relationship_type:string) {return this.desktopPost('createMediaRelationship',{source_msg_id,target_msg_id,relationship_type});}
    getMembershipStatus() {return this.desktopPost('getMembershipStatus',{});}
    collaborationReturnUrl():string|null {
      try{const path=sessionStorage.getItem('rv-auth-return') || '';if(/^\/(collaborate\/[a-f0-9]{64}|collaboration-contribution\/[1-9][0-9]*\/[1-9][0-9]*|media\/[1-9][0-9]*|acquire\/[1-9][0-9]*|trade-checkout\/[1-9][0-9]*)$/.test(path))return path;}catch(_){}

      const workspace=localStorage.getItem('rovespier_collaboration_workspace_return');
      if(workspace && /^\/collaboration-contribution\/[1-9][0-9]*\/[1-9][0-9]*$/.test(workspace))return workspace;
      const token=localStorage.getItem('rovespier_collaboration_return');return token && /^[a-f0-9]{64}$/.test(token)?'/collaborate/'+token:null;
    }
    private desktopPost(endpoint:string,payload:any) {return this.http.post(this.appData.getApiUrl()+endpoint,this.jsonToURLEncoded({...payload,api_signature:this.getApiSignature()}),{headers:this.options});}


    tradeListings(offset=0){return this.desktopPost('tradeListings',{offset});}
    allMediaForSale(offset=0){return this.desktopPost('allMediaForSale',{offset});}
    userMediaForSale(offset=0){return this.desktopPost('userMediaForSale',{offset});}
    createTradeReservation(resale_id:number,quantity:number,idempotency_key:string){return this.desktopPost('createTradeReservation',{reservationData:{resale_id,quantity,idempotency_key}});}
    tradeReservationStatus(reservation_id:number){return this.desktopPost('tradeReservationStatus',{reservationData:{reservation_id}});}
    cancelTradeReservation(reservation_id:number){return this.desktopPost('cancelTradeReservation',{reservationData:{reservation_id}});}
    createTradePaymentIntent(reservation_id:number){return this.desktopPost('createTradePaymentIntent',{reservation_id});}
    finalizeTradePurchase(reservation_id:number,paymentIntentId:string){return this.desktopPost('finalizeTradePurchase',{reservation_id,paymentIntentId});}
    reconcileTradePayment(reservation_id:number){return this.desktopPost('reconcileTradePayment',{reservation_id});}
    abandonTradePayment(reservation_id:number){return this.desktopPost('abandonTradePayment',{reservation_id});}
    resellMedia(resaleData:any){return this.desktopPost('submitResale',{resaleData});}


 cancelAcquire(paymentIntentId:string){return this.desktopPost('cancelMediaAcquirePayment',{paymentIntentId});}
}
